// extracted by mini-css-extract-plugin
module.exports = {"face":"styles_face__3vBIO","wrap":"styles_wrap__2GjNL","textBlock":"styles_textBlock__1OjC-","name":"styles_name__1JaDn"};